import { BehaviorSubject } from "rxjs";
// import Helpers from "./helpers";

const Storage = {};

let items = {};

let obsrv = {};

const stored_in_memory = {};

const prefix = "vm_mb_";

Storage.get_obsrv = (setting) => {
	if (Object.keys(obsrv).indexOf(prefix + setting) === -1) {
		if (Object.keys(items).indexOf(prefix + setting) === -1) {
			items[prefix + setting] = null;
		}
		obsrv[prefix + setting] = new BehaviorSubject(items[prefix + setting]);
	}
	return obsrv[prefix + setting].asObservable();
};

Storage.get = (setting, look_in_browser_storage = false) => {
	if (Object.keys(items).indexOf(prefix + setting) !== -1) {
		return items[prefix + setting];
	} else {
		if (look_in_browser_storage) {
			let in_storage = window.localStorage.getItem(prefix + setting);
			if (in_storage) {
				if (in_storage === "true" || in_storage === "false") {
					return JSON.parse(in_storage);
				} else {
					// @todo support numbers

					if (in_storage.startsWith("{")) {
						try {
							return JSON.parse(in_storage);
						} catch (error) {
							return null;
						}
					} else {
						return in_storage;
					}
				}
			}
		}
		return null;
	}
};

Storage.set = (setting, val, store_in_browser = false, shared = false) => {
	items[prefix + setting] = val;
	if (store_in_browser) {
		if (typeof val !== "string") {
			window.localStorage.setItem(prefix + setting, JSON.stringify(val));
		} else {
			window.localStorage.setItem(prefix + setting, val);
		}
	}
	if (Object.keys(obsrv).indexOf(prefix + setting) === -1) {
		obsrv[prefix + setting] = new BehaviorSubject(items[prefix + setting]);
	}
	if (!shared) {
		stored_in_memory[setting] = true;
	}
	obsrv[prefix + setting].next(val);
};

Storage.setShared = (setting, val, store_in_browser = false) => {
	Storage.set(setting, val, store_in_browser, true);
};

Storage.clear = (setting) => {
	Storage.set(setting, null);
	if (window.localStorage.getItem(prefix + setting)) {
		window.localStorage.removeItem(prefix + setting);
	}
};

Storage.wipe = () => {
	let stored_in_browser = Object.keys(window.localStorage);
	for (let setting of stored_in_browser) {
		if (setting.startsWith(prefix)) {
			window.localStorage.removeItem(setting);
		}
	}
	for (let setting of Object.keys(stored_in_memory)) {
		Storage.clear(setting);
		delete stored_in_memory[setting];
	}
};

Storage.getOrfetch = (property, serviceFetcher, force_fetch = false) => {
	if (Storage.get(prefix + "fetching_" + property)) {
		return Storage.get(prefix + "fetching_" + property);
	}

	if (Storage.get(property) && !force_fetch) {
		// log("found " + property + " in storage.. ");
		let data = Storage.get(property);
		Storage.set(prefix + "fetching_" + property, false);
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		let f = serviceFetcher();
		Storage.set(prefix + "fetching_" + property, f);
		// log("fetching " + property + " from api..");

		f
			.then((res) => {
				Storage.set(prefix + "fetching_" + property, false);
			})
			.catch((err) => {
				Storage.set(prefix + "fetching_" + property, false);
			});
		return f;
	}
};

export default Storage;
